const STATUS = {
  saved: { label: 'Aguardando', tone: 'pendente' },
  indexing: { label: 'Indexando', tone: 'indexando' },
  ready: { label: 'Disponível para redação', tone: 'pronto' },
  indexFailed: { label: 'Falha na indexação', tone: 'falhou' },
  indexPending: { label: 'Em andamento no servidor', tone: 'indexando' },
  skipped: { label: 'Precisa de revisão', tone: 'pendente' },
}

const pieceTitle = (row, index) => row.documento?.titulo || row.documento?.arquivoNome || `Peça ${index + 1}`

export default function PecasAcervoBulkIndexStatus({ operation }) {
  const { rows = [], phase = 'idle', notice, stopping, reindexing, active, stop } = operation || {}
  if (phase === 'idle') return null

  const ready = rows.filter((row) => row.status === 'ready').length
  const failed = rows.filter((row) => row.status === 'indexFailed').length
  const pending = rows.length - ready - failed
  const processed = rows.filter((row) => ['ready', 'indexFailed', 'indexPending', 'skipped'].includes(row.status)).length
  const currentIndex = rows.findIndex((row) => row.status === 'indexing')
  const current = currentIndex >= 0 ? rows[currentIndex] : null
  const loading = phase === 'loading'

  return (
    <section className="acervo-panel acervo-bulk-index" aria-label={reindexing ? 'Reindexação do acervo' : 'Indexação de todas as peças'}>
      <div className="acervo-toolbar">
        <h3>{phase === 'done' ? reindexing ? 'Resultado da reindexação' : 'Resultado da indexação'
          : reindexing ? 'Reindexar acervo' : 'Indexar todas as peças'}</h3>
        {active && <button type="button" className="acervo-button" onClick={stop} disabled={stopping}>
          <i className={`fas ${stopping ? 'fa-spinner fa-spin' : 'fa-stop'}`} aria-hidden="true" />
          {stopping ? loading ? 'Parando…' : 'Aguardando esta peça…' : loading ? 'Parar' : 'Parar após esta peça'}
        </button>}
      </div>
      <p className="acervo-muted">Todas as áreas, independentemente dos filtros. {reindexing
        ? 'As peças já disponíveis também serão reindexadas com o modelo atual. Os documentos originais serão preservados.'
        : 'Peças já disponíveis são preservadas.'} Mantenha esta tela aberta.</p>

      <div className="acervo-bulk-index-progress" role="status" aria-live="polite" aria-atomic="true">
        {loading ? <p className="acervo-working"><i className="fas fa-spinner fa-spin" aria-hidden="true" />
          {stopping ? 'Interrompendo a consulta…' : 'Consultando todas as páginas da base jurídica…'}
        </p> : <>
          <div className="acervo-bulk-index-counts">
            <span><strong>{ready}</strong> prontas</span>
            <span><strong>{failed}</strong> com falha</span>
            <span><strong>{pending}</strong> pendentes</span>
          </div>
          {rows.length > 0 && <>
            <progress value={processed} max={rows.length} aria-label={`${processed} de ${rows.length} peças verificadas`} />
            <p className="acervo-bulk-index-caption">{processed} de {rows.length} peças verificadas nesta execução.</p>
          </>}
          {current && <p className="acervo-working acervo-bulk-index-current">
            <i className="fas fa-spinner fa-spin" aria-hidden="true" />
            <span>{stopping ? 'Aguardando a resposta de' : 'Indexando'}: <strong>{pieceTitle(current, currentIndex)}</strong></span>
          </p>}
        </>}
      </div>

      {notice && <p className="acervo-notice" role="status">{notice}</p>}
      {rows.length > 0 && <details className="acervo-bulk-index-results">
        <summary>Ver resultado por peça ({rows.length})</summary>
        <div className="acervo-bulk-index-scroll" tabIndex={0} role="region" aria-label="Resultados da indexação por peça">
          <ol>
            {rows.map((row, index) => {
              const status = STATUS[row.status] || STATUS.saved
              const explanation = row.error || (row.status === 'skipped'
                ? 'Confira o texto e a classificação desta peça antes de indexar.'
                : row.status === 'indexPending' ? 'A indexação continua no servidor. Atualize a lista para conferir o resultado.' : '')
              return <li key={row.id}>
                <div className="acervo-bulk-index-piece">
                  <strong>{pieceTitle(row, index)}</strong>
                  {row.documento?.arquivoNome && row.documento.arquivoNome !== row.documento.titulo &&
                    <span className="acervo-table-secondary">{row.documento.arquivoNome}</span>}
                </div>
                <span className={`acervo-status acervo-status-${status.tone}`}>
                  {row.status === 'indexing' && <i className="fas fa-spinner fa-spin" aria-hidden="true" />}{status.label}
                </span>
                {explanation && <p className={`acervo-bulk-index-explanation${row.status === 'indexFailed' ? ' is-error' : ''}`}>{explanation}</p>}
              </li>
            })}
          </ol>
        </div>
      </details>}
    </section>
  )
}
